import axios from "axios";
import { getToken } from "../../auth/authService";

const BASE = process.env.REACT_APP_BASE_URL;
const auth = () => ({ Authorization: `Bearer ${getToken()}` });

export const fetchMediaImages = async ({ page = 0, size = 20, visibility = "", imageUse = "", showDeleted = false } = {}) => {
  try {
    const params = { page, size };
    if (visibility) params.visibility = visibility;
    if (imageUse) params.imageUse = imageUse;
    if (showDeleted) params.showDeleted = true;
    console.log("[MediaImageService] GET params:", params);
    const res = await axios.get(`${BASE}/admin/media-images`, { headers: auth(), params });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: [], message: err.response?.data?.message || "Failed to fetch images" };
  }
};

export const fetchMediaImageById = async (id) => {
  try {
    const res = await axios.get(`${BASE}/admin/media-images/${id}`, { headers: auth() });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch image" };
  }
};

export const uploadMediaImage = async ({ file, name, visibility, imageUse, altText }) => {
  try {
    const form = new FormData();
    form.append("file", file);
    form.append("name", name);
    form.append("visibility", visibility);
    form.append("imageUse", imageUse);
    if (altText) form.append("altText", altText);
    const res = await axios.post(`${BASE}/admin/media-images/upload`, form, {
      headers: { ...auth(), "Content-Type": "multipart/form-data" },
    });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Upload failed" };
  }
};

export const replaceMediaImage = async (id, file) => {
  try {
    const form = new FormData();
    form.append("file", file);
    const res = await axios.put(`${BASE}/admin/media-images/${id}/replace`, form, {
      headers: { ...auth(), "Content-Type": "multipart/form-data" },
    });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Replace failed" };
  }
};

export const updateMediaImageMeta = async (id, { name, imageUse, altText }) => {
  try {
    const res = await axios.patch(`${BASE}/admin/media-images/${id}/meta`, { name, imageUse, altText }, { headers: auth() });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
  }
};

export const restoreMediaImage = async (id) => {
  try {
    const res = await axios.patch(`${BASE}/admin/media-images/${id}/restore`, {}, { headers: auth() });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Restore failed" };
  }
};

export const softDeleteMediaImage = async (id) => {
  try {
    const res = await axios.delete(`${BASE}/admin/media-images/${id}`, { headers: auth() });
    return { status: res.status };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
  }
};

export const hardDeleteMediaImage = async (id) => {
  try {
    const res = await axios.delete(`${BASE}/admin/media-images/${id}/hard`, { headers: auth() });
    return { status: res.status };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Hard delete failed" };
  }
};

// ── Media Image Uses ──────────────────────────────────────
export const fetchMediaImageUses = async () => {
  try {
    const res = await axios.get(`${BASE}/admin/media-image-uses`, { headers: auth() });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: [], message: err.response?.data?.message || "Failed to fetch image uses" };
  }
};

export const createMediaImageUse = async (name) => {
  try {
    const res = await axios.post(`${BASE}/admin/media-image-uses`, { name }, { headers: auth() });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
  }
};

export const deleteMediaImageUse = async (id) => {
  try {
    const res = await axios.delete(`${BASE}/admin/media-image-uses/${id}`, { headers: auth() });
    return { status: res.status };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
  }
};
